
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Lavorazione, GruppoLavorazioniPerLotto, Utente, FinderGruppoLavorazioniPerLotto, TextValueItem } from '@/models';
import { store, StoreActions } from '@/store';
import { Loading } from '@/components';
import dayjs from 'dayjs';
import { LoadingTemplateType } from './enums/LoadingTemplateType';
import { MultiSelectDescriptor } from '@/models/finders/MultiSelectDescriptor';

@Component({
  components: {
    Loading,
    FilterPopup: () => import('@/components/shared/FilterPopup.vue'),
    ProgressBar: () => import('@/components/shared/ProgressBar.vue')
  }
})
export default class GruppoLavorazionePerLottoTabella extends Vue {
    get page(): number { return store.state.uiGruppoLavorazioniPerLotto.pagina; }
    set page(value: number) { this.caricaGruppoLavorazioniPerLotto(value); }

    get itemsPerPage(): number {return store.state.uiGruppoLavorazioniPerLotto.dimensionePaginaListe }
    get pageCount(): number { return store.state.uiGruppoLavorazioniPerLotto.totPagine; }
    get numTotOrdini(): number { return store.state.uiGruppoLavorazioniPerLotto.totGruppi; }
    get user() { return store.state.currentUsr; }
    get userIsAdmin() {
        return (
        this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
        undefined
        );
    }
    get loading () {
        return store.state.uiGruppoLavorazioniPerLotto.loadingGruppoLavorazioniPerLotto;
    }

    get lavorazione(): Lavorazione | undefined {
        return store.state.lavorazioneCorrente;
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return LoadingTemplateType.DataTable;
    }

    
    filters: any = {}
    
    get dataSourceStagioni(): TextValueItem[] {
        return store.state.uiGruppoLavorazioniPerLottoDataSource.dataSourceStagioni;
    }
    get dataSourceLotti(): TextValueItem[] {
        return store.state.uiGruppoLavorazioniPerLottoDataSource.dataSourceLotti;
    }

    get headers(): any[] {
        return [
            {
                text: "Progresso",
                value: "Progresso",
                align: 'center',
                sortable: false,
            },
            {
                text: "Lotto",
                value: "Lotto",
                align: 'center',
                sortable: false,
                filter: {
                    type: 'multiselect',
                    field: 'lotto',
                    dataSource: this.dataSourceLotti
                }
            },
            {
                text: "Stagione",
                value: "Stagione",
                align: 'center',
                sortable: false,
                filter: {
                    type: 'multiselect',
                    field: 'stagione',
                    dataSource: this.dataSourceStagioni
                }
            },
            {
                text: "Capi lanciati",
                value: "Capi lanciati",
                align: 'center',
                sortable: false,
            },
            {
                text: "Capi rientrati",
                value: "Capi rientrati",
                align: 'center',
                sortable: false,
            },
            {
                text: "Carico Capi",
                value: "Carico Capi",
                align: 'center',
                sortable: false,
            }
        ];
    }
    get fornitore(): Utente | undefined {
        return store.state.fornitore;
    }
    private idFornitore: string = '';
    async created(){
        if (this.userIsAdmin) {
            if(this.fornitore){
                this.idFornitore = this.fornitore.id;
                await this.caricaDataSources();
                this.caricaGruppoLavorazioniPerLotto(1);
            }
        } else {
            this.idFornitore = this.user.idFornitore;
            await this.caricaDataSources();
            this.caricaGruppoLavorazioniPerLotto(1);
        }
    }

    private caricaGruppoLavorazioniPerLotto(pagina: number): void {
        let parametri: FinderGruppoLavorazioniPerLotto = {
            numeroPagina: pagina,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: store.state.uiGruppoLavorazioniPerLotto.dimensionePaginaListe,
            lotto: "", //TODO valorizzare da filtro, se necessario
        }

        if( this.filters["stagione"] && this.filters["stagione"].filter &&  this.filters["stagione"].filter.length){
            parametri.filtroStagione = new MultiSelectDescriptor(this.filters["stagione"].operator, this.filters["stagione"].filter);
        }

        if( this.filters["lotto"] && this.filters["lotto"].filter &&  this.filters["lotto"].filter.length){
            parametri.filtroLotto = new MultiSelectDescriptor(this.filters["lotto"].operator, this.filters["lotto"].filter);
        }

        store.dispatch(StoreActions.GetGruppoLavorazioniPerLotto, parametri);
    }

    private async caricaDataSources() {
        let parametri: FinderGruppoLavorazioniPerLotto = {
            numeroPagina: 0,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: 0,
            lotto: "", //TODO valorizzare da filtro, se necessario,
        }
        await store.dispatch(StoreActions.GetGruppoLavorazioniPerLottoDataSources, parametri)
    }

    get items(): GruppoLavorazioniPerLotto[] {
        return store.state.uiGruppoLavorazioniPerLotto.gruppoLavorazioniPerLotto;
    }

    onSetfilter(filterItem : any) {
        this.filters[filterItem.field] = {operator: filterItem.operator, filter: filterItem.filter};
        this.caricaGruppoLavorazioniPerLotto(1);
    }

    onRemoveFilter(filterItem : any) {
        delete this.filters[filterItem.field];
        this.caricaGruppoLavorazioniPerLotto(1);
    }

    @Watch("$store.state.fornitore")
    onCambioFiltri() {
        this.idFornitore = store.state.fornitore?.id ?? "";
        this.caricaGruppoLavorazioniPerLotto(store.state.uiGruppoLavorazioniPerLotto.pagina);
    }
}

